import React, { useState, useEffect, ComponentType } from "react";

// Define the props for the CustomIcon component
interface CustomIconProps {
  iconName: string;
  stroke?: string;
  fill?: string;
  width?: number | string;
  height?: number | string;
  [key: string]: any;
}

// Dynamic import helper to load SVGs as React components
const importIcon = async (
  iconName: string
): Promise<ComponentType<React.SVGProps<SVGSVGElement>> | null> => {
  try {
    const IconComponent = (await import(`public/icons/${iconName}.svg`))
      .default;
    return IconComponent;
  } catch (error) {
    console.error(`Icon "${iconName}" not found`);
    return null;
  }
};

const CustomIcon: React.FC<CustomIconProps> = ({ iconName, stroke }) => {
  const [IconComponent, setIconComponent] = useState<ComponentType<
    React.SVGProps<SVGSVGElement>
  > | null>(null);

  useEffect(() => {
    const loadIcon = async () => {
      const icon = await importIcon(iconName);
      setIconComponent(() => icon);
    };
    loadIcon();
  }, [iconName]);

  if (!IconComponent) return null;

  return <IconComponent stroke={stroke} />;
};

export default CustomIcon;
